import { defineMessages } from 'react-intl';

export default defineMessages({
  modify: {
    id: 'components.myaccount.chooseItemCard.modify',
    defaultMessage: 'Modify',
  },
});
